import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Printer } from 'lucide-react';
import { DeckProvider, EditAllowed, StaticCtx, useDeck } from '@/pres/store';
import { SlideRenderer } from '@/pres/SlideRenderer';
import { SLIDES } from '@/pres/slides';

export default function PrintView() {
  const { slug } = useParams();
  return (
    <DeckProvider slug={slug!}>
      <EditAllowed.Provider value={false}>
        <StaticCtx.Provider value={true}><PrintInner /></StaticCtx.Provider>
      </EditAllowed.Provider>
    </DeckProvider>
  );
}

function PrintInner() {
  const { loaded } = useDeck();
  useEffect(() => {
    if (!loaded) return;
    let t: any;
    (document as any).fonts?.ready?.then(() => { t = setTimeout(() => window.print(), 1600); });
    return () => clearTimeout(t);
  }, [loaded]);

  return (
    <div className="bg-neutral-800" data-testid="print-view">
      <div className="no-print sticky top-0 z-50 flex items-center gap-4 bg-black px-6 py-3 font-ui text-sm text-white">
        <span>Export PDF : choisissez « Enregistrer au format PDF », marges <b>Aucune</b>, et cochez <b>Graphiques d'arrière-plan</b>.</span>
        <button data-testid="print-button" onClick={() => window.print()} className="ml-auto flex items-center gap-2 rounded-full bg-blue-600 px-4 py-2 font-app font-semibold hover:bg-blue-500"><Printer size={16} /> Imprimer / PDF</button>
      </div>
      {loaded && SLIDES.map((d) => (
        <div key={d.id} className="print-page relative mx-auto my-6 overflow-hidden" style={{ width: 1600, height: 900 }} data-testid={`print-slide-${d.n}`}>
          <SlideRenderer d={d} />
        </div>
      ))}
    </div>
  );
}
